/**
 * Generates a query string from an object.
 */
function generateQueryParams(params: Record<any, any>): string {
  // biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
  if (!params || !Object.keys(params).length) {
    return '';
  }
  const encodedParams = Object.entries(params)
    .map((kv) => kv.map((item) => encodeURIComponent(item)).join('='))
    .join('&');

  return `?${encodedParams}`;
}

/**
 * Removes knowed query parameters from a url.
 */
function removeQueryParametersFromUrl(url: string, parameters: string[]): string {
  try {
    const targetUrl = new URL(url);

    parameters.forEach((param) => {
      targetUrl.searchParams.delete(param);
    });

    // This is needed when BIAS returns error code as query param.
    // somehow, the #. were appended to the url, even though BIAS does not send them
    if (targetUrl.hash === '#.') {
      targetUrl.hash = '';
    }

    return targetUrl.href;
  } catch {
    return url;
  }
}

/**
 * Get a query parameter from the url.
 */
function getQueryParameter(param: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(param);
}

/**
 * Removes query parameters from the url and updates the current url in the seamless router.
 */
function removeQueryParametersForSeamlessRouter(params: string[], origin = window.location.href): void {
  const resolvedUrl = removeQueryParametersFromUrl(origin, params);

  window.history.replaceState(null, '', resolvedUrl);

  if (window.seamlessRouter) {
    window.seamlessRouter.currentUrl = new URL(resolvedUrl);
  }
}

/**
 * Checks if a url is absolute.
 */
function isAbsoluteUrl(entry: string): boolean {
  const regex = /^(?:[a-z]+:)?\/\//i;

  return regex.test(entry);
}

export {
  generateQueryParams,
  removeQueryParametersFromUrl,
  getQueryParameter,
  removeQueryParametersForSeamlessRouter,
  isAbsoluteUrl,
};
